import * as React from 'react';
import { useState } from 'react';
import MobileCard from 'src/components/mobile/MobileCard';
import SimpleTable from 'src/components/common/SimpleTable/SimpleTable';
import classNames from 'classnames';
import styles from '../../../assets/case-component-tab.module.scss';
import ColumnForm from './ColumnForm';
import { Paginated } from 'src/services/api-handlers/pagination';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import { IProvider } from 'src/types/provider';
import { IBonus } from 'src/types/bonus';
import GeneralEnumService from 'src/enumerables/general-enum';
import { numberWithCommas } from '../../../../../../../../../helpers/format';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRetweet } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { generateBonus, getBonuses } from '../../../../../../../../../store/actions/bonus-actions';
import Router from '../../../../../../../../../navigation/router';
import { routes } from '../../../../../../../../../navigation';
import { Link } from 'react-router-dom';

export interface StateProps {}
export interface DispatchProps {}

export interface OwnProps {
    provider: Partial<IProvider> | null;
    data: Paginated<IBonus>;
    month: { monthEnd: string; monthStart: string };
    getData: any;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const BonusTable: React.FunctionComponent<Props> = ({ month, data, provider, getData }: Props) => {
    const [opened, setOpened] = useState(-5);
    const [formColumn, setFormColumn] = useState<any>(false);
    const [openDrop, setOpenDrop] = useState<boolean>(false);
    const dataSessionComponents: any = [];
    const { totalPages, page } = data;
    let totalFull = 0;
    const isMobile = window.innerWidth <= 800;

    const dispatch = useDispatch();

    data.list.forEach((itSes: any) => {
        totalFull += itSes.amount ? +itSes.amount : 0;
        if (`${formColumn}` === `${itSes['id']}`) {
            dataSessionComponents.push({
                ColumnForm: ColumnForm,
                setOpenDrop,
                getData,
                month,
                providerId: provider?.id,
                ...itSes,
            });
            return false;
        }

        const GeneralEnumStatus = GeneralEnumService ? GeneralEnumService.getEnum('BonusStatus') : {};
        const GeneralEnumType = GeneralEnumService ? GeneralEnumService.getEnum('BonusType') : {};
        const statusItems: SelectObject[] = getValFromEnum(GeneralEnumStatus);
        const typeItems: SelectObject[] = getValFromEnum(GeneralEnumType);

        let valueStatus: any = statusItems.find((it) => it.value === itSes.status);
        valueStatus = valueStatus ? valueStatus.label : '';

        let valueType: any = typeItems.find((it) => it.value === itSes.bonusType);
        valueType = valueType ? valueType.label : '';

        dataSessionComponents.push({
            ...itSes,
            referral: (
                <Link
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: itSes?.referral?.id,
                        tab: 'main-info',
                        subId: '',
                    })}
                    target={'_blank'}
                >
                    {itSes?.referral?.fullName}
                </Link>
            ),
            status: <div style={{ minWidth: 150, maxWidth: 150 }}>{valueStatus}</div>,
            bonusType: <div style={{ minWidth: 150, maxWidth: 150 }}>{valueType}</div>,
            createdAt: itSes.createdAt ? changeToZeroMoment(itSes['createdAt'], 'MMM D, YYYY') : '',
            amount: itSes.amount ? `$${numberWithCommas(itSes.amount)}` : '',
        });
    });

    if (formColumn === true) {
        if (isMobile) {
            dataSessionComponents.unshift({
                ColumnForm: ColumnForm,
                month,
                getData,
                providerId: provider?.id,
                setOpenDrop,
            });
        } else {
            dataSessionComponents.push({
                ColumnForm: ColumnForm,
                month,
                getData,
                providerId: provider?.id,
                setOpenDrop,
            });
        }
    } else {
        if (data.list.length) {
            dataSessionComponents.push({
                totalColumn: true,
                amount: `$${numberWithCommas(totalFull)}`,
            });
        }
    }

    return (
        <div className={'d-flex flex-column'}>
            <div
                style={openDrop ? { overflow: 'visible' } : {}}
                className={classNames(styles.Table, 'responsive-table')}
            >
                {isMobile ? (
                    <MobileCard
                        type={'bonus'}
                        action={(val) => {
                            setFormColumn(val);
                            if (!val) {
                                setOpened(-5);
                            }
                        }}
                        opened={opened}
                        setOpened={setOpened}
                        columns={[
                            { id: 'referral', label: 'Referred Provider', cellStyle: 'normal' },
                            { id: 'info', label: 'Note', cellStyle: 'normal' },
                            { id: 'createdAt', label: 'Date', cellStyle: 'normal' },
                            { id: 'amount', label: 'Amount $', cellStyle: 'normal' },
                            { id: 'bonusType', label: 'Type', cellStyle: 'normal' },
                            { id: 'status', label: 'Status', cellStyle: 'normal' },
                        ]}
                        pagination={{ page, totalPages }}
                        data={dataSessionComponents}
                    />
                ) : (
                    <SimpleTable
                        action={setFormColumn}
                        data={dataSessionComponents}
                        pagination={{ page, totalPages }}
                        columns={[
                            { id: 'referral', label: 'Referred Provider', cellStyle: 'normal' },
                            { id: 'info', label: 'Note', cellStyle: 'normal' },
                            { id: 'createdAt', label: 'Date', cellStyle: 'normal' },
                            { id: 'amount', label: 'Amount $', cellStyle: 'normal' },
                            { id: 'bonusType', label: 'Type', cellStyle: 'normal' },
                            { id: 'status', label: 'Status', cellStyle: 'normal' },
                        ]}
                    />
                )}

                <div className={'d-flex justify-content-end'}>
                    <button
                        className={'btn mr-1 ml-1 mb-2 btn-outline-info'}
                        type={'button'}
                        onClick={() => {
                            dispatch(
                                generateBonus(
                                    {
                                        userId: provider?.id,
                                        month: month,
                                        provider: provider?.id,
                                    },
                                    {
                                        resolve: () => {
                                            dispatch(
                                                getBonuses({
                                                    page: 1,
                                                    filters: {
                                                        'provider.id': provider?.id,
                                                        'createdAt[before]': month.monthEnd,
                                                        'createdAt[after]': month.monthStart,
                                                    },
                                                    itemsPerPage: 9000,
                                                }),
                                            );
                                        },
                                        reject: (errorMessage: string) => {
                                            toast.error(errorMessage);
                                        },
                                    },
                                ),
                            );
                        }}
                    >
                        <FontAwesomeIcon icon={faRetweet} /> Refresh bonus of the user
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BonusTable;
